import { render, staticRenderFns } from "./TicketLogsTable.vue?vue&type=template&id=dfd70318&scoped=true&"
import script from "./TicketLogsTable.vue?vue&type=script&lang=js&"
export * from "./TicketLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./TicketLogsTable.vue?vue&type=style&index=0&id=dfd70318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd70318",
  null
  
)

export default component.exports